import { render, staticRenderFns } from "./BindsDateIcon.vue?vue&type=template&id=cbe7e898&"
import script from "./BindsDateIcon.vue?vue&type=script&lang=js&"
export * from "./BindsDateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports